<script setup>
import {
    formataCpf
} from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Membro" :conteudo="props.solicitacao.dados.membro_nome"
        :detalhe="`CPF: ${formataCpf(props.solicitacao.dados.membro_cpf)}`" />

    <LabelDados titulo="Justificativa"
        v-if="props.solicitacao.dados.justificativa && !props.solicitacao.dados.is_parcial"
        :conteudo="props.solicitacao.dados.justificativa || 'Não informada'" tamanho_div="col-12" />

</template>